import { Identifier } from "../../core";
export class CustomParameterTypeId extends Identifier {
    constructor(id) {
        super("CustomParameterTypeId", id);
    }
}
